module.exports = __webpack_public_path__ + "img/zhipinban2.79258acb.jpg";